export { TabContent, type TabContentProps } from './TabContent';
export { default } from './TabContent';

